import { getAccessIcon } from 'utils/helperMethods';
import { ExpandIcon } from 'assets/svg/ExpandIcon';
import { PpaTableRowType } from 'types/ppa';
import type { InternalProjectRecord, InternalScenarioRecord, InternalTableRecord } from '../types';
import ScenarioNameCell from './ScenarioNameCell';

type ProjectNameCellProps = {
    record: InternalTableRecord;
    expanded: boolean;
    showAnalyticsCheckbox: boolean;
    onToggleExpansion: (projectKey: string, projectId: number) => void;
    onScenarioClick?: (record: InternalScenarioRecord) => void;
};

const ProjectNameCell = ({
    record,
    expanded,
    showAnalyticsCheckbox,
    onToggleExpansion,
    onScenarioClick,
}: ProjectNameCellProps) => {
    if (record.row_type === PpaTableRowType.Scenario) {
        return (
            <ScenarioNameCell
                record={record}
                showAnalyticsCheckbox={showAnalyticsCheckbox}
                onClick={onScenarioClick}
            />
        );
    }

    const projectRecord = record as InternalProjectRecord;

    return (
        <div
            role="button"
            tabIndex={0}
            aria-expanded={expanded}
            aria-label={expanded ? 'Collapse scenarios' : 'Expand scenarios'}
            className="flex items-center justify-between gap-2 cursor-pointer"
            onClick={(event) => {
                event.stopPropagation();
                onToggleExpansion(projectRecord.key, projectRecord.project_id);
            }}
            onKeyDown={(event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                event.stopPropagation();
                onToggleExpansion(projectRecord.key, projectRecord.project_id);
            }}
        >
            <div className="flex items-center justify-between">
                <span className="font-medium text-fontColor">{projectRecord.project_name}</span>
                {getAccessIcon(Boolean(projectRecord?.is_private), { top: 0, marginLeft: 15 })}
            </div>
            <span
                className="inline-flex items-center justify-center text-fontColor transition-transform duration-150"
                style={{ transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)' }}
            >
                <ExpandIcon />
            </span>
        </div>
    );
};

export default ProjectNameCell;
